<template>
  <div>
    <div>
      <img class="banner" src="../assets/images/banner.jpg" width="1440" height="560" alt="" />
    </div>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb-4 mt-2 text-center">
            <h2 class="pt-5 pb-a JY-features" style="font-size: 26px;">自动配载 · 低价透明 · 线上车队 · 供应链管理</h2>
            <h4 style="font-size: 16px; line-height:180%;">极速接单，低价实惠，经严格标准甄选承运人，保证运输快速、安全。</h4>
          </div>
        </div>
      </div>
        <!--div class="container ">
            <div class="row JY-features">
                <div class="col-lg-4 col-md-6 col-sm-12 text-center">
                    <img class="rounded-circle" alt="140x140" style="width: 140px; height: 140px;" src="../assets/images/140X140.png" data-holder-rendered="true">
                    <h3 class="fn-color-red pt-a pb-a"><em>极速响应</em></h3>
                    <p><em>5秒下单，10秒内接单<br/>随叫随到，10分钟内到达用车点</em></p>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 text-center">
                    <img class="rounded-circle" alt="140x140" style="width: 140px; height: 140px;" src="../assets/images/140X140-2.png" data-holder-rendered="true">
                    <h3 class="fn-color-red pt-a pb-a"><em>低价透明</em></h3>
                    <p><em>低价实惠，比个体司机便宜40%<br/>按照里程、车型计费，收费有标准</em></p>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 text-center">
                    <img class="rounded-circle" alt="140x140" style="width: 140px; height: 140px;" src="../assets/images/140X140-3.png" data-holder-rendered="true">
                    <h3 class="fn-color-red pt-a pb-a"><em>运力充足</em></h3>
                    <p><em>经过严格培训和考核的认证司机<br/>99.8%用户好评司机</em></p>
                </div>
            </div>
        </div-->
      <div class="container pt-5">
        <div class="row JY-new">
          <div class="col-sm-6 col-lg-3">
            <img src="../assets/images/new-1.png" alt="">
            <h3>公司动态</h3>
            <li>嘉盈智慧物流（天津）有限公司，于2018年7月在天津市自贸区市场监管局注册成立，注册资金为人民币3000万元。经营范围包括许可项目：道路货物运输（网络货运）；第二类增值电信业务。公司秉承以科技助力物流实践，以人才培养为发展基础的理念，建设物流专业领域的技术研发团队，在传统物流实践中汲取先进的互联网和物联网技术，不断开发和实施企业信息化、智能化应用，开拓员工的创造性，拥有一支充满实战经验、敏捷睿智的物流专业化团队。</li>
            <!-- <p><a class="btn btn-link" href="#">查看更多 ></a></p> -->
          </div>
          <div class="col-sm-6 col-lg-3" id="index">
            <img src="../assets/images/tousu.jpg" alt="">
            <h3><a @click="showConsult()">咨询投诉</a></h3>
            <li>
              嘉盈智慧物流（天津）有限公司以及其自行研发的嘉盈吉运平台，致力于通过“智慧互联+车货匹配”为广大货主及驾驶人提供更加全面、省心、优惠的服务。为此，嘉盈物流专门建立了极具透明清晰化的咨询、投诉以及评价体系，希望嘉盈吉运平台以更新高效、精准、敏捷的服务为广大货主及驾驶人朋友们排忧解难，无论您所需要解决的是评价、咨询还是投诉，请按以下途径联络我们，我们将在24小时之内给您满意答复。
            </li>
            <!-- <p><a class="btn btn-link" href="">查看更多 ></a></p> -->
          </div>
          <div class="col-sm-6 col-lg-3">
            <img src="../assets/images/va-banner-e.png" alt="">
            <h3>司机评分公示</h3>
            <li>嘉盈智慧物（天津）有限公司秉承对货运物流行业督促监察的责任，将承运人纳入服务质量信誉考核体系，并进行计分考核围绕装货考核、途中考核、卸货考核、货主考核四方面进行综合考核评价，并将结果进行公示。</li>
            <p><a class="btn btn-link" href="#" @click="showCompanyDynamicList()">查看更多 -></a></p>
          </div>
          <div class="col-sm-6 col-lg-3">
            <img src="../assets/images/va-new-b.png" alt="">
            <h3>考核管理办法</h3>
            <li>嘉盈吉运平台对承运人实行评分机制，目的是为了规范各承运人的物流服务作业，督促各承运人不断提升物流服务水平和服务质量，以达成各承运人对本平台做出的服务质量承诺，现制定本标准，请点击链接查看。</li>
            <p><a class="btn btn-link" href="#" @click="showAppraisalManagement()">查看更多 -></a></p>
          </div>
        </div>
      </div>
    </section>
    <div class="JY-contactUs" style="margin-top:50px;" data-stellar-background-ratio="0.5">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 mt-4 mb-2 text-center">
            <div class="JY-bggray">
              <h2 class=" JY-partner">联系我们</h2>
              <h4>免费咨询热线：022-2532-6184</h4>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="咨询投诉" :visible.sync="dialogFormVisible" width="60%">
      <el-form ref="consuleForm" :model="dataForm" :rules="addrules" label-position="right" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系方式" prop="tel">
              <el-input v-model="dataForm.tel" placeholder="邮箱/电话"></el-input>
            </el-form-item> 
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="咨询内容" prop="content">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="dataForm.content"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">提交</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
  data() {
    return {
      dialogFormVisible: false,
      dataForm: {
        id:null,
        tel:null,
        content:null,
      },
      addrules:{
        tel: [{ required: true, message: '必填' }],
        content: [{ required: true, message: '必填' }],
      },
    }
  },
  mounted() {
    const ViewerDom = document.getElementById('index');
    const viewer = new Viewer(ViewerDom, {
      // 配置
    })
  },
  methods:{
    showConsult(){
      this.dialogFormVisible=true
    },
    handleSubmit(){
      this.$refs['consuleForm'].validate((valid)=>{
        if(!valid) return

        this.dialogFormVisible=false
        this.$message.success('提交成功，客服将尽快联系您！')
      })
    },
    showCompanyDynamicList(){
      this.$router.push("/companydynamic/detail?id=1");
    },
    showAppraisalManagement(){
      this.$router.push("/rulemanner/detail?id=1");
    },
  },
};
</script>
<style>
.banner {
  object-fit: cover;
  width: 100%;
}
#index {
  width: 100%;
  ul {
    li {
      width: 24%;
      height: 200px;
      margin-right: 1%;
      margin-bottom: 20px;
      cursor: pointer;
      display: inline-block;
      &:nth-child(4n) {
        margin-right: 0;
      }
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/Index.vue